if (!customElements.get('moss-stockists')) {
  customElements.define('moss-stockists', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const on = (el, type, handler) => el.addEventListener(type, handler, { signal: this.abort.signal });
      this.map = this.querySelector('[data-map]');
      this.tiles = this.querySelector('[data-tiles]');
      this.pins = this.querySelector('[data-pins]');
      this.zoom = 12;
      this.center = [53.32397, -1.42277];
      this.filter = 'all';
      this.collectCards();
      on(document, 'shopify:section:load', event => {
        if (!event.target.querySelector('[data-stockist-extra]')) return;
        this.querySelectorAll('[data-location]').forEach(el => {
          if (el.dataset.owner === event.detail.sectionId) el.remove();
        });
        this.collectCards(); this.update();
      });
      on(document, 'shopify:section:unload', event => {
        if (event.detail.sectionId === this.dataset.mainOwner) return;
        this.querySelectorAll('[data-location]').forEach(el => {
          if (el.dataset.owner === event.detail.sectionId) el.remove();
        });
        this.collectCards(); this.update();
      });
      on(this.querySelector('[data-search]'), 'input', () => this.update());
      this.querySelectorAll('[data-filter]').forEach(button => on(button, 'click', () => {
        this.filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.update();
      }));
      this.querySelectorAll('[data-zoom]').forEach(button => on(button, 'click', () => {
        this.zoom = Math.max(5, Math.min(18, this.zoom + Number(button.dataset.zoom))); this.render();
      }));
      on(this.querySelector('[data-fit]'), 'click', () => this.fit());
      on(this.pins, 'click', event => {
        const button = event.target.closest('[data-pin]');
        if (button) this.select(this.cards[Number(button.dataset.pin)], true);
      });
      on(this.map, 'keydown', event => {
        if (event.target !== this.map) return;
        const directions = { ArrowLeft: [-120, 0], ArrowRight: [120, 0], ArrowUp: [0, -120], ArrowDown: [0, 120] };
        if (directions[event.key]) {
          event.preventDefault(); const p = this.project(...this.center); const d = directions[event.key];
          this.center = this.unproject(p[0] + d[0], p[1] + d[1]); this.render();
        }
      });
      on(this.map, 'pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button,a')) return;
        event.preventDefault();
        this.drag = { x: event.clientX, y: event.clientY, center: this.project(...this.center), id: event.pointerId };
        this.map.setPointerCapture(event.pointerId);
      });
      on(this.map, 'pointermove', event => {
        if (!this.drag) return;
        const transform = 'translate(' + (event.clientX - this.drag.x) + 'px,' + (event.clientY - this.drag.y) + 'px)';
        this.tiles.style.transform = transform; this.pins.style.transform = transform;
      });
      const finishDrag = event => {
        if (!this.drag) return;
        this.center = this.unproject(this.drag.center[0] - event.clientX + this.drag.x, this.drag.center[1] - event.clientY + this.drag.y);
        this.drag = null; this.tiles.style.transform = ''; this.pins.style.transform = ''; this.render();
      };
      on(this.map, 'pointerup', finishDrag);
      on(this.map, 'pointercancel', () => { this.drag = null; this.tiles.style.transform = ''; this.pins.style.transform = ''; });
      this.resize = new ResizeObserver(() => this.render());
      this.resize.observe(this.map);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect();
      document.querySelectorAll('[data-stockist-extra]').forEach(group => {
        this.querySelectorAll('[data-location]').forEach(el => {
          if (el.dataset.owner === group.dataset.stockistExtra) group.append(el);
        });
      });
      this.ready = false;
    }
    collectCards() {
      const list = this.querySelector('[data-cards]');
      document.querySelectorAll('[data-stockist-extra] [data-location]').forEach(el => list.append(el));
      const elements = [...list.querySelectorAll('[data-location]')].sort((a, b) => a.dataset.name.localeCompare(b.dataset.name));
      elements.forEach(el => list.append(el));
      this.cards = elements.map((el, i) => {
        const lat = Number(el.dataset.lat), lng = Number(el.dataset.lng);
        return { el, index: i + 1, name: el.dataset.name, category: el.dataset.category, lat, lng,
          mapped: el.dataset.lat.trim() !== '' && el.dataset.lng.trim() !== '' && Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 85 && Math.abs(lng) <= 180 };
      });
      this.cards.forEach(card => {
        const button = card.el.querySelector('[data-show-map]');
        button.hidden = !card.mapped;
        button.onclick = () => { this.select(card); this.map.scrollIntoView({ block: 'center', behavior: 'smooth' }); this.map.focus({ preventScroll: true }); };
      });
    }
    project(lat, lng) {
      const scale = 256 * 2 ** this.zoom;
      const sin = Math.sin(Math.max(-85, Math.min(85, lat)) * Math.PI / 180);
      return [(lng + 180) / 360 * scale, (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * scale];
    }
    unproject(x, y) {
      const scale = 256 * 2 ** this.zoom;
      return [Math.max(-85, Math.min(85, Math.atan(Math.sinh(Math.PI * (1 - 2 * y / scale))) * 180 / Math.PI)), ((x / scale * 360) % 360 + 360) % 360 - 180];
    }
    update() {
      const query = this.querySelector('[data-search]').value.toLocaleLowerCase().trim();
      this.visible = this.cards.filter(card => {
        const shown = (this.filter === 'all' || this.filter === card.category) && (card.name + ' ' + card.el.querySelector('[data-address]').textContent).toLocaleLowerCase().includes(query);
        card.el.hidden = !shown; return shown;
      });
      this.querySelector('[data-count]').textContent = this.visible.length === 1 ? this.dataset.singleLabel : this.dataset.countLabel.replace('[count]', String(this.visible.length));
      this.querySelector('[data-empty]').hidden = this.visible.length > 0;
      this.fit();
    }
    fit() {
      const coords = this.visible.filter(card => card.mapped);
      this.cards.forEach(card => card.el.classList.remove('is-selected'));
      this.selected = null;
      if (!coords.length) { this.zoom = 11; this.center = [53.35, -1.45]; this.render(); return; }
      const latitudes = coords.map(c => c.lat), longitudes = coords.map(c => c.lng);
      this.center = [(Math.min(...latitudes) + Math.max(...latitudes)) / 2, (Math.min(...longitudes) + Math.max(...longitudes)) / 2];
      this.zoom = coords.length === 1 ? 13 : 15;
      while (this.zoom > 5) {
        const points = coords.map(c => this.project(c.lat, c.lng));
        const xs = points.map(p => p[0]), ys = points.map(p => p[1]);
        if (Math.max(...xs) - Math.min(...xs) < this.map.clientWidth - 90 && Math.max(...ys) - Math.min(...ys) < this.map.clientHeight - 100) break;
        this.zoom--;
      }
      this.render();
    }
    select(card, fromPin = false) {
      this.selected = card; this.center = [card.lat, card.lng]; this.zoom = Math.max(this.zoom, 14);
      this.cards.forEach(c => c.el.classList.toggle('is-selected', c === card));
      this.render();
      if (fromPin) {
        card.el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        const heading = card.el.querySelector('h2'); heading.tabIndex = -1; heading.focus({ preventScroll: true });
      }
    }
    render() {
      if (!this.map || !this.visible || !this.map.clientWidth) return;
      const center = this.project(...this.center), width = this.map.clientWidth, height = this.map.clientHeight;
      const left = center[0] - width / 2, top = center[1] - height / 2, n = 2 ** this.zoom;
      const old = new Map([...this.tiles.children].map(el => [el.dataset.key, el]));
      for (let x = Math.floor(left / 256); x <= Math.floor((left + width) / 256); x++) {
        for (let y = Math.max(0, Math.floor(top / 256)); y <= Math.min(n - 1, Math.floor((top + height) / 256)); y++) {
          const key = this.zoom + '/' + x + '/' + y;
          let tile = old.get(key); old.delete(key);
          if (!tile) {
            tile = document.createElement('img'); tile.alt = ''; tile.draggable = false; tile.dataset.key = key;
            tile.referrerPolicy = 'strict-origin-when-cross-origin';
            tile.src = 'https://tile.openstreetmap.org/' + this.zoom + '/' + ((x % n + n) % n) + '/' + y + '.png';
            tile.addEventListener('error', () => { this.querySelector('[data-map-error]').hidden = false; }, { once: true });
            this.tiles.append(tile);
          }
          tile.style.left = (x * 256 - left) + 'px'; tile.style.top = (y * 256 - top) + 'px';
        }
      }
      old.forEach(el => el.remove());
      this.pins.replaceChildren();
      this.visible.filter(c => c.mapped).forEach(card => {
        const p = this.project(card.lat, card.lng);
        const shared = this.visible.filter(c => c.mapped && c.lat === card.lat && c.lng === card.lng);
        if (shared.length > 1) {
          const angle = 2 * Math.PI * shared.indexOf(card) / shared.length;
          p[0] += Math.cos(angle) * 24; p[1] += Math.sin(angle) * 24;
        }
        const pin = document.createElement('button'); pin.type = 'button'; pin.className = 'stockists-pin';
        pin.textContent = String(card.index); pin.title = card.name; pin.setAttribute('aria-label', card.name);
        pin.setAttribute('aria-pressed', String(this.selected === card)); pin.dataset.pin = String(this.cards.indexOf(card));
        pin.style.left = (p[0] - left) + 'px'; pin.style.top = (p[1] - top) + 'px'; this.pins.append(pin);
      });
    }
  });
}
